import styled from 'styled-components';

export const DDListingsWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;

  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0;
  }
`;

export const DDListingsDivider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0 0 32px 0;
`;

export const DDSectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  margin: 0 0 16px 0;
  line-height: 28px;
`;

export const ViewDetailsButton = styled.a`
  display: inline-block;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  min-width: 200px;
  text-decoration: none;
  display: flex;
  box-shadow:
    0px 2px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;
  height: 48px;
  background-color: #cc0000;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 100px;
  text-decoration: none;
  cursor: pointer;

  .item-icon {
    display: inline-block;
    width: 28px;
    margin-right: -28px;
    font-size: 28px;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;
  }

  &:hover {
    background-color: #aa0000;
    color: #ffffff;
    text-decoration: none;
  }

  @media (max-width: 767px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ViewDetailsButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 767px) {
    justify-content: stretch;
  }
`;
